(() => {
  const root = document.querySelector('[data-sa-pdp]');
  if (!root) return;

  const stage = root.querySelector('[data-sa-stage]');
  const stagePlay = root.querySelector('[data-sa-stage-play]');
  const lightbox = root.querySelector('[data-sa-lightbox]');
  const lightboxImg = root.querySelector('[data-sa-lightbox-img]');
  const lightboxCount = root.querySelector('[data-sa-lightbox-count]');
  let mediaItems = [];
  const mediaJson = document.getElementById('sa-pdp-media');
  if (mediaJson) {
    try {
      mediaItems = JSON.parse(mediaJson.textContent || '[]');
    } catch (error) {
      mediaItems = [];
    }
  }
  let mediaIndex = 0;
  let syncPersonalizePreview = null;
  let syncMobileBarPrice = null;
  let syncMobilePersonalizeButton = null;

  const isVideo = (item) => item && (item.type === 'video' || item.type === 'external_video');

  const showMedia = (index) => {
    if (!mediaItems.length) return;
    mediaIndex = (index + mediaItems.length) % mediaItems.length;
    const item = mediaItems[mediaIndex];
    if (stage && item.src) {
      stage.src = item.src;
      const sharedHero = (root.classList.contains('sa-pdp--console') || root.classList.contains('sa-pdp--towel') || root.classList.contains('sa-pdp--pet')) && mediaIndex === 0;
      stage.classList.toggle('sa-pdp__shared-img', sharedHero);
    }
    if (lightboxImg && item.src) lightboxImg.src = item.src;
    if (stagePlay) {
      stagePlay.hidden = !isVideo(item);
    }
    if (lightboxCount) lightboxCount.textContent = `${mediaIndex + 1} / ${mediaItems.length}`;
    root.querySelectorAll('[data-sa-thumb]').forEach((el) => {
      el.classList.toggle('is-active', Number(el.dataset.index) === mediaIndex);
    });
    root.querySelectorAll('[data-sa-gallery-dot]').forEach((el) => {
      el.classList.toggle('is-active', Number(el.dataset.index) === mediaIndex);
    });
    syncPersonalizePreview?.();
  };

  const openLightbox = (index) => {
    showMedia(index);
    if (!lightbox) return;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  };

  root.querySelectorAll('[data-sa-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.index) || 0));
  });
  root.querySelector('[data-sa-more]')?.addEventListener('click', () => openLightbox(5));
  root.querySelectorAll('[data-sa-open-lightbox]').forEach((el) => {
    el.addEventListener('click', () => openLightbox(Number(el.dataset.index) || 0));
  });
  root.querySelector('[data-sa-stage-prev]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    showMedia(mediaIndex - 1);
  });
  root.querySelector('[data-sa-stage-next]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    showMedia(mediaIndex + 1);
  });
  stagePlay?.addEventListener('click', (event) => {
    event.stopPropagation();
    if (stagePlay.hasAttribute('data-sa-video-open')) return;
    openLightbox(mediaIndex);
  });
  root.querySelector('[data-sa-stage-wrap]')?.addEventListener('click', (event) => {
    if (event.target.closest('[data-sa-stage-prev], [data-sa-stage-next], [data-sa-stage-play]')) return;
    openLightbox(mediaIndex);
  });
  root.querySelector('[data-sa-lightbox-prev]')?.addEventListener('click', () => showMedia(mediaIndex - 1));
  root.querySelector('[data-sa-lightbox-next]')?.addEventListener('click', () => showMedia(mediaIndex + 1));
  root.querySelector('[data-sa-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (event) => {
    if (lightbox?.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showMedia(mediaIndex - 1);
    if (event.key === 'ArrowRight') showMedia(mediaIndex + 1);
  });
  if (mediaItems.length) showMedia(0);

  root.querySelectorAll('[data-sa-inline-video]').forEach((card) => {
    const player = card.querySelector('[data-sa-inline-video-player]');
    if (!player) return;

    const playInlineVideo = () => {
      const src = player.getAttribute('data-sa-inline-video-src');
      if (!src) return;
      if (!player.querySelector('source')) {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        player.appendChild(source);
        player.load();
      }
      player.muted = true;
      const play = player.play();
      if (play && typeof play.then === 'function') {
        play.then(() => card.classList.add('is-playing')).catch(() => {});
      }
    };

    card.addEventListener('click', (event) => {
      if (event.target.closest('video')) return;
      playInlineVideo();
    });
    player.addEventListener('click', playInlineVideo);
    card.addEventListener('focus', playInlineVideo);
    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        playInlineVideo();
      }
    });
    player.addEventListener('play', () => card.classList.add('is-playing'));
    player.addEventListener('pause', () => card.classList.remove('is-playing'));
    player.addEventListener('ended', () => card.classList.remove('is-playing'));

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            playInlineVideo();
          } else if (!entry.isIntersecting && !player.paused) {
            player.pause();
          }
        });
      }, { threshold: [0, 0.5] });
      observer.observe(card);
    }
  });

  const qtyInput = root.querySelector('[data-sa-qty-input]');
  root.querySelectorAll('[data-sa-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-sa-qty')));
      qtyInput.value = String(next);
    });
  });

  const variantInput = root.querySelector('[data-sa-variant-id]');
  const priceEl = root.querySelector('[data-sa-price]');
  const addBtn = root.querySelector('.sa-pdp__atc');
  const buyNowBtn = root.querySelector('.sa-pdp__buy-now');
  const checkoutReturn = root.querySelector('[data-sa-checkout-return]');
  const productForm = root.querySelector('.sa-pdp__form');

  const isLocalThemePreview = () => {
    const host = window.location.hostname;
    return (
      host === '127.0.0.1' ||
      host === 'localhost' ||
      window.location.search.includes('preview_theme_id')
    );
  };

  const shopCheckoutOrigin = () => {
    const shopUrl = root.getAttribute('data-shop-url');
    if (shopUrl) {
      try {
        return new URL(shopUrl).origin;
      } catch (error) {
        /* fall through */
      }
    }
    const shopDomain = window.Shopify?.shop;
    return shopDomain ? `https://${shopDomain}` : '';
  };

  productForm?.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    const isBuyNow =
      submitter?.classList.contains('sa-pdp__buy-now') || submitter?.hasAttribute('data-sa-buy-now');

    if (isBuyNow) {
      checkoutReturn?.removeAttribute('disabled');
    } else {
      checkoutReturn?.setAttribute('disabled', 'disabled');
      return;
    }

    const checkoutOrigin = shopCheckoutOrigin();
    if (!checkoutOrigin || !isLocalThemePreview()) return;

    event.preventDefault();
    const previousAction = productForm.getAttribute('action') || '';
    productForm.setAttribute('action', `${checkoutOrigin}/cart/add`);
    productForm.submit();
    if (previousAction) productForm.setAttribute('action', previousAction);
    else productForm.removeAttribute('action');
  });
  let variants = [];
  const variantJson = document.getElementById('sa-pdp-variants');
  if (variantJson) {
    try {
      variants = JSON.parse(variantJson.textContent || '[]');
    } catch (error) {
      variants = [];
    }
  }

  const selectedOptions = () =>
    [...root.querySelectorAll('[data-sa-option]')]
      .filter((input) => input.type === 'hidden' || input.checked)
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((input) => input.value);

  const productHandle = root.getAttribute('data-handle') || '';
  const formatShopPrice = (variantId) => {
    const usd = window.SeatArmourUsdPrices;
    if (!usd || !productHandle || !variantId) return '';
    return usd
      .variantShopCents(productHandle, variantId)
      .then((cents) => (Number.isFinite(cents) ? usd.formatUsdFromCents(cents) : ''));
  };

  const syncVariant = () => {
    if (!variants.length || !variantInput) return;
    const options = selectedOptions();
    const match = variants.find((variant) =>
      options.length === variant.options.length &&
      options.every((value, index) => variant.options[index] === value)
    );
    if (!match) return;
    variantInput.value = match.id;
    if (priceEl) {
      formatShopPrice(match.id).then((label) => {
        if (!label) return;
        const target = priceEl.querySelector('[data-sa-shop-price]') || priceEl;
        target.textContent = label;
        target.removeAttribute?.('aria-busy');
        root.setAttribute('data-price', label);
        syncMobileBarPrice?.();
      });
    }
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
    if (buyNowBtn) buyNowBtn.disabled = !match.available;
    root.querySelectorAll('.sa-pdp__swatch').forEach((label) => {
      label.classList.toggle('is-selected', label.querySelector('input')?.checked);
    });
    syncPersonalizePreview?.();
    syncMobileBarPrice?.();
  };

  root.querySelectorAll('[data-sa-option]').forEach((input) => {
    input.addEventListener('change', () => {
      const label = input.closest('fieldset')?.querySelector('[data-sa-option-label]');
      if (label) label.textContent = input.value;
      syncVariant();
    });
  });

  syncVariant();

  root.querySelectorAll('[data-sa-color-fallback]').forEach((input) => {
    input.addEventListener('change', () => {
      const fieldset = input.closest('fieldset');
      const label = fieldset?.querySelector('[data-sa-option-label]');
      if (label) label.textContent = input.value;
      fieldset?.querySelectorAll('.sa-pdp__swatch').forEach((swatch) => {
        swatch.classList.toggle('is-selected', swatch.querySelector('input')?.checked);
      });
      syncPersonalizePreview?.();
      syncMobileBarPrice?.();
    });
  });

  root.querySelector('[data-sa-fit-select]')?.addEventListener('change', (event) => {
    const value = event.target.value;
    const match = [...root.querySelectorAll('[data-sa-option]')].find((input) => input.value === value);
    if (match) {
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  const fitBrandSelect = root.querySelector('[data-sa-picker][data-navigate="stay"] [data-sa-picker-brand]');
  const fitValueInput = root.querySelector('[data-sa-fit-value]');
  fitBrandSelect?.addEventListener('change', () => {
    const selected = fitBrandSelect.selectedOptions[0];
    const label = selected?.textContent?.trim() || '';
    if (!fitValueInput) return;
    if (fitBrandSelect.value) {
      fitValueInput.name = 'properties[Vehicle]';
      fitValueInput.value = label;
    } else {
      fitValueInput.removeAttribute('name');
      fitValueInput.value = '';
    }
  });

  const videoFrame = root.querySelector('[data-sa-video]');
  const playBtn = root.querySelector('[data-sa-video-play]');
  if (videoFrame && playBtn) {
    playBtn.addEventListener('click', () => {
      const video = videoFrame.querySelector('video');
      if (video) {
        video.setAttribute('controls', '');
        video.play();
        videoFrame.classList.add('is-playing');
        return;
      }
      videoFrame.classList.add('is-playing');
    });
  }

  const wishBtn = root.querySelector('[data-sa-wish]');
  if (wishBtn) {
    const wishKey = 'sa-wishlist';
    const readWish = () => {
      try {
        const ids = JSON.parse(localStorage.getItem(wishKey) || '[]');
        return Array.isArray(ids) ? ids : [];
      } catch (error) {
        return [];
      }
    };
    const syncWish = () => {
      const on = readWish().includes(String(wishBtn.dataset.productId));
      wishBtn.classList.toggle('is-on', on);
      wishBtn.setAttribute('aria-pressed', String(on));
    };
    wishBtn.addEventListener('click', () => {
      const id = String(wishBtn.dataset.productId);
      const ids = readWish();
      const next = ids.includes(id) ? ids.filter((item) => item !== id) : [...ids, id];
      localStorage.setItem(wishKey, JSON.stringify(next));
      syncWish();
    });
    syncWish();
  }

  const personalizeRoot = root.querySelector('[data-sa-personalize]');
  if (personalizeRoot) {
    const personalizeKind = personalizeRoot.dataset.saPersonalizeKind || 'pet';
    const defaultOpenLabel =
      personalizeRoot.dataset.saPersonalizeDefaultLabel ||
      (personalizeKind === 'towel' ? 'Personalize your towel' : 'Personalize your pet bed');
    const modal = root.querySelector('[data-sa-personalize-modal]');
    const openBtn = root.querySelector('[data-sa-personalize-open]');
    const openLabel = root.querySelector('[data-sa-personalize-open-label]');
    const summary = root.querySelector('[data-sa-personalize-summary]');
    const nameInput = personalizeRoot.querySelector('[data-sa-personalize-name], [data-sa-pet-name]');
    const threadColorInput = personalizeRoot.querySelector('[data-sa-thread-color]');
    const colorPresets = personalizeRoot.querySelectorAll('[data-sa-color-presets] [data-color-hex]');
    const fontInputs = personalizeRoot.querySelectorAll('[data-sa-personalize-font], [data-sa-pet-font]');
    const carLogoToggle = personalizeRoot.querySelector('[data-sa-car-logo]');
    const carLogoField = personalizeRoot.querySelector('[data-sa-car-logo-field]');
    const carLogoProp = personalizeRoot.querySelector('[data-sa-car-logo-prop]');
    const carLogoPreviews = root.querySelectorAll('[data-sa-car-logo-preview]');
    const PREVIEW_FONT_SCALE = 1.42;
    const overlay = root.querySelector('[data-sa-personalize-overlay]');
    const namePreviews = root.querySelectorAll('[data-sa-personalize-name-preview], [data-sa-pet-name-preview]');
    const previewPlaceholder =
      modal?.querySelector('[data-sa-pet-name-placeholder]')?.dataset.saPetNamePlaceholder ||
      (personalizeKind === 'towel' ? 'Alex' : 'Bailey');

    const previewImg = modal?.querySelector('[data-sa-personalize-preview-img]');
    const productPreviewSrc = previewImg?.getAttribute('src') || '';

    const getSelectedProductColorImage = () => {
      const selectedColor = root.querySelector('[data-sa-product-color]:checked')?.value?.trim().toLowerCase() || '';
      const previewKey = (key) => root.dataset[`colorPreview${key}`] || '';
      if (personalizeKind === 'towel') {
        if (selectedColor.includes('stripe')) return previewKey('BlueStripe');
        if (selectedColor.includes('black')) return previewKey('Black');
        if (selectedColor.includes('orange')) return previewKey('Orange');
        if (selectedColor.includes('tan') || selectedColor.includes('beige')) return previewKey('Tan');
        if (selectedColor.includes('gray') || selectedColor.includes('grey') || selectedColor.includes('silver')) {
          return previewKey('Gray');
        }
        if (selectedColor.includes('blue') || selectedColor.includes('navy')) return previewKey('Blue');
        return '';
      }
      if (selectedColor.includes('black')) return previewKey('Black');
      if (selectedColor.includes('gray') || selectedColor.includes('grey') || selectedColor.includes('silver')) {
        return previewKey('Gray');
      }
      if (selectedColor.includes('tan') || selectedColor.includes('beige')) return previewKey('Tan');
      return '';
    };

    const syncPreviewProductImage = () => {
      if (!previewImg) return;
      const colorImage = getSelectedProductColorImage();
      if (colorImage) {
        previewImg.src = colorImage;
        return;
      }
      const item = mediaItems[mediaIndex];
      if (item?.type === 'image' && mediaIndex > 0) {
        previewImg.src = item.src;
      } else {
        previewImg.src = productPreviewSrc;
      }
    };

    const getPreviewPath = (textEl) => textEl.querySelector('textPath') || textEl;

    const fitNameSize = (textEl, nameLength, scale) => {
      const baseSize = Number.parseFloat(textEl.dataset.saNameBaseSize || '2') || 2;
      const layout = textEl.dataset.saPetNameLayout || 'sample';
      const baseMaxChars = layout === 'hero' ? 9 : 12;
      const maxChars = Math.max(layout === 'hero' ? 6 : 8, Math.round(baseMaxChars / Math.sqrt(scale)));
      let size = baseSize * scale;
      if (nameLength > maxChars) {
        size *= maxChars / nameLength;
      }
      return Math.max(size, baseSize * scale * 0.65);
    };

    const normalizeHex = (hex) => {
      if (!hex) return '#1a1a1a';
      let value = hex.trim().toLowerCase();
      if (!value.startsWith('#')) value = `#${value}`;
      if (value.length === 4) {
        value = `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`;
      }
      return value;
    };

    const isLightColor = (hex) => {
      const normalized = normalizeHex(hex).replace('#', '');
      const r = Number.parseInt(normalized.slice(0, 2), 16);
      const g = Number.parseInt(normalized.slice(2, 4), 16);
      const b = Number.parseInt(normalized.slice(4, 6), 16);
      return (r * 299 + g * 587 + b * 114) / 1000 > 160;
    };

    const brightenForPreview = (hex, minLuma = 150) => {
      const normalized = normalizeHex(hex).replace('#', '');
      let r = Number.parseInt(normalized.slice(0, 2), 16);
      let g = Number.parseInt(normalized.slice(2, 4), 16);
      let b = Number.parseInt(normalized.slice(4, 6), 16);
      let luma = (r * 299 + g * 587 + b * 114) / 1000;
      if (luma >= minLuma) return normalizeHex(hex);

      const mix = Math.min(1, (minLuma - luma) / 110);
      r = Math.round(r + (255 - r) * mix * 0.72);
      g = Math.round(g + (255 - g) * mix * 0.72);
      b = Math.round(b + (255 - b) * mix * 0.72);
      return `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
    };

    const PREVIEW_ZONES = {
      sample: { pet: { x: 22, y: 8, w: 56, h: 34 }, print: { x: 27, y: 35, w: 46, h: 10 } },
      hero: { pet: { x: 22, y: 8, w: 56, h: 34 }, print: { x: 27, y: 35, w: 46, h: 10 } },
    };

    const zonesOverlap = (a, b) => !(
      a.x + a.w <= b.x ||
      b.x + b.w <= a.x ||
      a.y + a.h <= b.y ||
      b.y + b.h <= a.y
    );

    const analyzePreviewPlacement = () => {
      const note = modal?.querySelector('[data-sa-personalize-placement-note]');
      if (!note) return;

      if (personalizeKind === 'towel') {
        note.textContent = 'Embroidered below the logo on the towel face.';
        note.classList.add('is-safe');
        return;
      }

      const stage = modal?.querySelector('[data-sa-personalize-layout="sample"]');
      const layout = stage?.dataset.saPersonalizeLayout || 'sample';
      const zones = PREVIEW_ZONES[layout];
      if (!zones) return;

      const safe = !zonesOverlap(zones.pet, zones.print);
      note.textContent = safe
        ? 'Stitched on the front label — pet-free zone.'
        : 'Adjusted to the label area to avoid the pet.';
      note.classList.toggle('is-safe', safe);
    };

    const getSelectedThread = () => {
      const hex = normalizeHex(threadColorInput?.value || '#1a1a1a');
      const preset = [...colorPresets].find((el) => normalizeHex(el.dataset.colorHex) === hex);
      return { hex, label: preset?.getAttribute('aria-label') || 'Black' };
    };

    const getSelectedFont = () => {
      const selected = personalizeRoot.querySelector('[data-sa-personalize-font]:checked, [data-sa-pet-font]:checked');
      return {
        label: selected?.value || 'Script',
        stack: selected?.dataset.fontStack || 'cursive',
      };
    };

    const getSelectedCarLogo = () => {
      const enabled = Boolean(carLogoToggle?.checked);
      const brand = (carLogoField?.dataset.logoBrand || '').trim();
      return {
        enabled: enabled && Boolean(brand),
        brand,
        src: brand ? carLogoField?.dataset.logoSrc || '' : '',
      };
    };

    const syncCarLogoControls = () => {
      const logo = getSelectedCarLogo();
      if (carLogoProp) {
        if (logo.enabled) {
          carLogoProp.disabled = false;
          carLogoProp.value = logo.brand;
        } else {
          carLogoProp.value = '';
          carLogoProp.disabled = true;
        }
      }
    };

    const syncCarLogoPreview = () => {
      const logo = getSelectedCarLogo();
      carLogoPreviews.forEach((badge) => {
        const img = badge.querySelector('[data-sa-car-logo-img]');
        const text = badge.querySelector('[data-sa-car-logo-text]');
        if (!logo.enabled) {
          badge.hidden = true;
          if (img) {
            img.hidden = true;
            img.removeAttribute('src');
            img.alt = '';
          }
          if (text) text.textContent = '';
          return;
        }

        badge.hidden = false;
        if (logo.src && img) {
          img.hidden = false;
          img.src = logo.src;
          img.alt = `${logo.brand} logo`;
          img.onerror = () => {
            img.hidden = true;
            img.removeAttribute('src');
            if (text) text.textContent = logo.brand;
          };
          if (text) text.textContent = '';
        } else {
          if (img) {
            img.hidden = true;
            img.removeAttribute('src');
            img.alt = '';
          }
          if (text) text.textContent = logo.brand;
        }
      });
    };

    const syncColorPresetState = () => {
      const current = getSelectedThread().hex;
      colorPresets.forEach((preset) => {
        const match = normalizeHex(preset.dataset.colorHex) === current;
        preset.classList.toggle('is-selected', match);
        preset.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    };

    const setThreadColor = (hex) => {
      const normalized = normalizeHex(hex);
      if (threadColorInput) threadColorInput.value = normalized;
      syncColorPresetState();
    };

    const syncFontChoiceState = () => {
      personalizeRoot.querySelectorAll('.sa-pdp__personalize-font').forEach((el) => {
        el.classList.toggle('is-selected', Boolean(el.querySelector('input:checked')));
      });
    };

    const applyPreviewStyle = () => {
      const thread = getSelectedThread();
      const font = getSelectedFont();
      const enteredName = nameInput?.value.trim() || '';
      const displayName = enteredName || previewPlaceholder;
      const isPlaceholder = !enteredName;

      namePreviews.forEach((textEl) => {
        const textPath = getPreviewPath(textEl);
        const layout = textEl.dataset.saPetNameLayout || 'sample';
        const isHero = layout === 'hero';

        if (isHero && !enteredName) {
          textEl.hidden = true;
          textPath.textContent = '';
          return;
        }

        textPath.textContent = displayName;
        textEl.hidden = false;
        const previewFill = thread.hex;
        const lightThread = isLightColor(previewFill);
        textEl.setAttribute('fill', previewFill);
        textEl.setAttribute('font-family', font.stack);
        textEl.setAttribute('font-size', String(fitNameSize(textEl, displayName.length, PREVIEW_FONT_SCALE)));
        textEl.setAttribute('font-weight', font.label === 'Block' ? '800' : '700');
        textEl.setAttribute('letter-spacing', font.label === 'Block' ? '0.1' : '0.04');
        textEl.style.opacity = '1';
        textEl.style.textTransform = font.label === 'Block' ? 'uppercase' : 'capitalize';
        textEl.classList.toggle('sa-pdp__personalize-name-text--block', font.label === 'Block');
        textEl.classList.toggle('is-placeholder', isPlaceholder && !isHero);
        textEl.classList.toggle('is-light-thread', lightThread);
        textEl.classList.toggle('is-dark-thread', !lightThread);

        if (!lightThread) {
          textEl.setAttribute('stroke', 'rgba(255, 255, 255, 0.38)');
          textEl.setAttribute('stroke-width', '0.07');
          textEl.setAttribute('paint-order', 'stroke fill');
        } else {
          textEl.setAttribute('stroke', 'rgba(0, 0, 0, 0.22)');
          textEl.setAttribute('stroke-width', '0.05');
          textEl.setAttribute('paint-order', 'stroke fill');
        }
      });

      syncCarLogoPreview();
      analyzePreviewPlacement();
    };

    const updatePreviewText = () => {
      syncCarLogoControls();
      applyPreviewStyle();
      syncPersonalizePreview();
      updateSummary();
    };

    const updateSummary = () => {
      const name = nameInput?.value.trim() || '';
      const thread = getSelectedThread();
      const font = getSelectedFont();
      const logo = getSelectedCarLogo();
      if (!summary) return;
      if (!name && !logo.enabled) {
        summary.hidden = true;
        summary.textContent = '';
        if (openLabel) openLabel.textContent = defaultOpenLabel;
        syncMobilePersonalizeButton?.();
        return;
      }
      summary.hidden = false;
      const parts = [];
      if (name) parts.push(`Name: ${name}`);
      parts.push(`${thread.label} thread`);
      parts.push(`${font.label} font`);
      if (logo.enabled) parts.push(`${logo.brand} logo`);
      parts.push('10–12 in print width');
      summary.textContent = parts.join(' · ');
      if (openLabel) openLabel.textContent = 'Edit personalization';
      syncMobilePersonalizeButton?.();
    };

    syncPersonalizePreview = () => {
      syncPreviewProductImage();
      if (!overlay) return;
      const onHero = mediaIndex === 0;
      const hasName = Boolean(nameInput?.value.trim());
      const logo = getSelectedCarLogo();
      const show = onHero && (hasName || logo.enabled);
      overlay.hidden = !show;
      overlay.setAttribute('aria-hidden', show ? 'false' : 'true');
      overlay.classList.toggle('is-visible', show);
      overlay.classList.toggle('has-name', hasName);
      overlay.classList.toggle('has-logo', logo.enabled);
    };

    const openModal = () => {
      if (!modal) return;
      syncPreviewProductImage();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      nameInput?.focus();
    };

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      if (!lightbox || lightbox.hidden) document.body.style.overflow = '';
      updateSummary();
    };

    openBtn?.addEventListener('click', openModal);
    root.querySelector('[data-sa-personalize-done]')?.addEventListener('click', closeModal);
    root.querySelectorAll('[data-sa-personalize-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') closeModal();
    });

    nameInput?.addEventListener('input', updatePreviewText);
    colorPresets.forEach((preset) => {
      preset.addEventListener('click', () => {
        setThreadColor(preset.dataset.colorHex);
        updatePreviewText();
      });
    });
    fontInputs.forEach((input) => {
      input.addEventListener('change', () => {
        syncFontChoiceState();
        updatePreviewText();
      });
    });
    carLogoToggle?.addEventListener('change', updatePreviewText);

    syncFontChoiceState();
    syncColorPresetState();
    updatePreviewText();
  }

  const MOBILE_PDP_MAX = 749;
  const mobilePdpMq = window.matchMedia(`(max-width: ${MOBILE_PDP_MAX}px)`);
  const galleryEl = root.querySelector('.sa-pdp__gallery');
  const buyCol = root.querySelector('.sa-pdp__buy');
  const stageWrap = root.querySelector('[data-sa-stage-wrap]');

  const findColorFieldset = () =>
    [...root.querySelectorAll('.sa-pdp__option')].find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      return legend && /color|colour/i.test(legend.textContent || '');
    }) ||
    root.querySelector('.sa-pdp__option .sa-pdp__swatch--dot')?.closest('.sa-pdp__option') ||
    null;

  const summaryHeadNodes = () => {
    const nodes = [];
    const titleRow = buyCol?.querySelector(':scope > .sa-pdp__title-row');
    if (titleRow) nodes.push(titleRow);
    else {
      const heading = buyCol?.querySelector(':scope > h1');
      if (heading) nodes.push(heading);
    }
    buyCol?.querySelectorAll(':scope > .sa-pdp__rating, :scope > .sa-pdp__price').forEach((el) => nodes.push(el));
    const colorFieldset = findColorFieldset();
    if (colorFieldset) nodes.push(colorFieldset);
    return nodes.filter(Boolean);
  };

  let mobileSummaryEl = null;
  let mobileSummaryAnchors = [];
  let mobileBarEl = null;
  let galleryDotsEl = null;

  const captureSummaryAnchors = (nodes) => {
    nodes.forEach((node) => {
      if (node.parentElement === mobileSummaryEl) return;
      let record = mobileSummaryAnchors.find((entry) => entry.el === node);
      if (!record) {
        record = { el: node };
        mobileSummaryAnchors.push(record);
      }
      record.parent = node.parentElement;
      record.next = node.nextElementSibling;
    });
  };

  const ensureGalleryDots = () => {
    if (!galleryEl || galleryDotsEl) return;
    galleryDotsEl = document.createElement('div');
    galleryDotsEl.className = 'sa-pdp__gallery-dots';
    galleryDotsEl.setAttribute('role', 'tablist');
    galleryDotsEl.setAttribute('aria-label', 'Product images');
    galleryEl.appendChild(galleryDotsEl);

    const count = Math.max(mediaItems.length, 1);
    for (let i = 0; i < count; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sa-pdp__gallery-dot';
      dot.dataset.saGalleryDot = '';
      dot.dataset.index = String(i);
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Image ${i + 1} of ${count}`);
      dot.addEventListener('click', () => showMedia(i));
      galleryDotsEl.appendChild(dot);
    }
    showMedia(mediaIndex);
  };

  const mountMobileSummary = () => {
    if (!galleryEl || !buyCol) return;
    ensureGalleryDots();
    const nodes = summaryHeadNodes();
    if (!nodes.length) return;

    captureSummaryAnchors(nodes);

    if (!mobileSummaryEl) {
      mobileSummaryEl = document.createElement('div');
      mobileSummaryEl.className = 'sa-pdp__mobile-summary';
      galleryEl.insertAdjacentElement('afterend', mobileSummaryEl);
    }

    const formId = root.querySelector('.sa-pdp__form')?.id;
    nodes.forEach((node) => {
      if (node.parentElement !== mobileSummaryEl) mobileSummaryEl.appendChild(node);
      if (formId && node.matches?.('.sa-pdp__option')) {
        node.querySelectorAll('input, select, textarea, button').forEach((control) => {
          control.setAttribute('form', formId);
        });
      }
    });
    root.classList.add('sa-pdp--mobile-layout');
  };

  const unmountMobileSummary = () => {
    if (!mobileSummaryAnchors.length) return;
    mobileSummaryAnchors.forEach(({ el, parent, next }) => {
      if (!el?.isConnected) return;
      el.querySelectorAll('[form]').forEach((control) => control.removeAttribute('form'));
      if (!parent?.isConnected) return;
      if (next && next.parentElement === parent) parent.insertBefore(el, next);
      else parent.appendChild(el);
    });
    mobileSummaryEl?.remove();
    mobileSummaryEl = null;
    root.classList.remove('sa-pdp--mobile-layout');
  };

  const closeMobileColorPopover = () => {
    mobileBarEl?.querySelectorAll('.sa-pdp__mobile-color-picker.is-open').forEach((picker) => {
      picker.classList.remove('is-open');
      picker.querySelector('[data-sa-mobile-color-popover]')?.setAttribute('hidden', '');
      picker.querySelector('[data-sa-mobile-color-trigger]')?.setAttribute('aria-expanded', 'false');
    });
  };

  const buildMobileBarSwatchChip = (swatch, input, asButton = true) => {
    const btn = document.createElement(asButton ? 'button' : 'span');
    if (asButton) btn.type = 'button';
    btn.className = 'sa-pdp__mobile-bar-swatch';
    btn.title = swatch.title || input.value;
    btn.setAttribute('aria-label', swatch.title || input.value);
    btn.classList.toggle('is-selected', input.checked);
    const dot = swatch.querySelector('i');
    if (dot) {
      const chip = document.createElement('i');
      chip.style.cssText = dot.getAttribute('style') || '';
      if (swatch.classList.contains('sa-pdp__swatch--stripe')) btn.classList.add('sa-pdp__swatch--stripe');
      if (swatch.classList.contains('sa-pdp__swatch--gold')) btn.classList.add('sa-pdp__swatch--gold');
      btn.appendChild(chip);
    } else {
      btn.textContent = input.value;
    }
    return btn;
  };

  const renderMobileBarColors = () => {
    const host = mobileBarEl?.querySelector('[data-sa-mobile-bar-colors]');
    const fieldset = findColorFieldset();
    if (!host) return;
    closeMobileColorPopover();
    if (!fieldset) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    const swatches = [...fieldset.querySelectorAll('.sa-pdp__swatch')].filter((swatch) =>
      swatch.querySelector('input[type="radio"]')
    );
    if (!swatches.length) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    host.hidden = false;

    let picker = host.querySelector('.sa-pdp__mobile-color-picker');
    if (!picker) {
      host.innerHTML = `
        <div class="sa-pdp__mobile-color-picker">
          <button type="button" class="sa-pdp__mobile-color-trigger" data-sa-mobile-color-trigger aria-expanded="false" aria-haspopup="listbox">
            <span class="sa-pdp__mobile-color-trigger-chip" data-sa-mobile-color-chip></span>
            <span class="sa-pdp__mobile-color-trigger-caret" aria-hidden="true"></span>
          </button>
          <div class="sa-pdp__mobile-color-popover" data-sa-mobile-color-popover hidden role="listbox"></div>
        </div>
      `;
      picker = host.querySelector('.sa-pdp__mobile-color-picker');
    }

    const trigger = picker.querySelector('[data-sa-mobile-color-trigger]');
    const chipHost = picker.querySelector('[data-sa-mobile-color-chip]');
    const popover = picker.querySelector('[data-sa-mobile-color-popover]');
    const caret = picker.querySelector('.sa-pdp__mobile-color-trigger-caret');
    if (!trigger || !chipHost || !popover) return;

    popover.innerHTML = '';
    let selected = swatches[0];
    swatches.forEach((swatch) => {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;
      if (input.checked) selected = swatch;

      if (swatches.length > 1) {
        const option = buildMobileBarSwatchChip(swatch, input);
        option.classList.add('sa-pdp__mobile-color-option');
        option.dataset.saMobileColorOption = '';
        option.addEventListener('click', (event) => {
          event.stopPropagation();
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          closeMobileColorPopover();
          renderMobileBarColors();
        });
        popover.appendChild(option);
      }
    });

    const selectedInput = selected.querySelector('input[type="radio"]');
    chipHost.innerHTML = '';
    if (selectedInput) {
      chipHost.appendChild(buildMobileBarSwatchChip(selected, selectedInput, false));
      trigger.setAttribute('aria-label', `Color: ${selected.title || selectedInput.value}`);
    }

    const multi = swatches.length > 1;
    caret.hidden = !multi;
    trigger.disabled = !multi;
    trigger.setAttribute('aria-expanded', 'false');
    popover.hidden = true;
    picker.classList.remove('is-open');
  };

  const ensureMobileBar = () => {
    if (mobileBarEl) return;
    mobileBarEl = document.createElement('div');
    mobileBarEl.className = 'sa-pdp__mobile-bar';
    mobileBarEl.dataset.saMobileBar = '';
    mobileBarEl.innerHTML = `
      <div class="sa-pdp__mobile-bar-row">
        <button type="button" class="sa-pdp__personalize-link sa-pdp__mobile-bar-customize" data-sa-mobile-customize hidden></button>
        <div class="sa-pdp__mobile-bar-colors" data-sa-mobile-bar-colors hidden></div>
      </div>
      <div class="sa-pdp__mobile-bar-actions">
        <button type="button" class="sa-pdp__mobile-bar-atc">Add to cart</button>
        <button type="button" class="sa-pdp__mobile-bar-buy" data-sa-mobile-buy>Buy now</button>
      </div>
    `;
    root.appendChild(mobileBarEl);

    const customizeBtn = mobileBarEl.querySelector('[data-sa-mobile-customize]');
    syncMobilePersonalizeButton = () => {
      if (!customizeBtn) return;
      const personalizeOpen = root.querySelector('[data-sa-personalize-open]');
      if (!personalizeOpen) {
        customizeBtn.hidden = true;
        customizeBtn.innerHTML = '';
        customizeBtn.removeAttribute('aria-label');
        return;
      }
      customizeBtn.innerHTML = personalizeOpen.innerHTML;
      const labelEl = personalizeOpen.querySelector('[data-sa-personalize-open-label]');
      const subEl = personalizeOpen.querySelector('.sa-pdp__personalize-link-copy em');
      const labelText = labelEl?.textContent?.trim() || '';
      const subText = subEl?.textContent?.trim() || '';
      customizeBtn.hidden = !labelText;
      if (customizeBtn.hidden) {
        customizeBtn.innerHTML = '';
        customizeBtn.removeAttribute('aria-label');
        return;
      }
      customizeBtn.setAttribute('aria-label', subText ? `${labelText}. ${subText}` : labelText);
    };
    customizeBtn?.addEventListener('click', () => {
      root.querySelector('[data-sa-personalize-open]')?.click();
    });
    syncMobilePersonalizeButton();

    mobileBarEl.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-sa-mobile-color-trigger]');
      if (!trigger || trigger.disabled) return;
      event.stopPropagation();
      const picker = trigger.closest('.sa-pdp__mobile-color-picker');
      const popover = picker?.querySelector('[data-sa-mobile-color-popover]');
      if (!picker || !popover) return;
      const open = !picker.classList.contains('is-open');
      closeMobileColorPopover();
      if (open) {
        picker.classList.add('is-open');
        popover.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    document.addEventListener('click', (event) => {
      if (!mobilePdpMq.matches || !mobileBarEl) return;
      if (event.target.closest('.sa-pdp__mobile-color-picker')) return;
      closeMobileColorPopover();
    });

    mobileBarEl.querySelector('.sa-pdp__mobile-bar-atc')?.addEventListener('click', () => {
      addBtn?.click();
    });
    mobileBarEl.querySelector('[data-sa-mobile-buy]')?.addEventListener('click', () => {
      buyNowBtn?.click();
    });

    syncMobileBarPrice = () => {
      const buyBtn = mobileBarEl.querySelector('[data-sa-mobile-buy]');
      if (!buyBtn) return;
      const price = root.getAttribute('data-price');
      buyBtn.textContent = price ? `Buy at ${price}` : 'Buy now';
      if (addBtn) {
        const atc = mobileBarEl.querySelector('.sa-pdp__mobile-bar-atc');
        if (atc) {
          atc.disabled = addBtn.disabled;
          atc.textContent = addBtn.textContent;
        }
      }
      if (buyNowBtn) buyBtn.disabled = buyNowBtn.disabled;
      renderMobileBarColors();
    };
  };

  const syncMobileLayout = () => {
    if (mobilePdpMq.matches) {
      ensureMobileBar();
      mountMobileSummary();
      mobileBarEl?.removeAttribute('hidden');
      syncMobilePersonalizeButton?.();
      syncMobileBarPrice?.();
    } else {
      mobileBarEl?.setAttribute('hidden', '');
      unmountMobileSummary();
    }
  };

  if (galleryEl && buyCol) {
    ensureGalleryDots();
    syncMobileLayout();
    mobilePdpMq.addEventListener('change', syncMobileLayout);
    window.addEventListener('resize', syncMobileLayout);

    if (stageWrap && mediaItems.length > 1) {
      let touchStartX = 0;
      stageWrap.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0]?.clientX || 0;
        },
        { passive: true }
      );
      stageWrap.addEventListener(
        'touchend',
        (event) => {
          if (!mobilePdpMq.matches) return;
          const touchEndX = event.changedTouches[0]?.clientX || 0;
          const delta = touchEndX - touchStartX;
          if (Math.abs(delta) < 48) return;
          showMedia(mediaIndex + (delta < 0 ? 1 : -1));
        },
        { passive: true }
      );
    }
  }
})();
